import React from "react";
import CTable from "components/common/Table";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import IconButton from "components/common/IconButton";
import Stack from "components/common/Stack";
import Link from "components/common/Link";
import Drawer from "components/common/Drawer";
import ChargingPointShowDrawer from "./ChargingPointShowDrawer";
import AddChrgingPoint from "./ChargingPoints&Connrctors/AddChrgingPoint";
import AddChargingConnectors from "./ChargingPoints&Connrctors/AddChargingConnectors";
import EditChargingConnector from "./ChargingPoints&Connrctors/EditChargingConnector";
import EditChargingPoint from "./ChargingPoints&Connrctors/EditChargingPoint";
import { InputLabel, Select } from "@mui/material";
import MenuItem from "components/common/MenuItem";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Switch from "../common/Switch";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ChargingStationTable = ({
  handleGoBack,
  handleOnchangeSelectCity,
  vendorSelect,
  data,
  handleChangeConnector,
  isLoading,
  //
  handleSubmitConnector,
  handleSubmitEditConnector,
  hendleChangeConnectorAdd,
  //
  handleSubmitAddChPoint,
  handleSubmitEditChPoint,

  handleAddConnector,
  handleChangeChPointAdd,
  handleAddChPoint,
  handleAddChPointClose,
  handleShowChPointClose,
  handleOpenAddConnectorDr,
  handleCloseAddConnectorDr,
  viewDrawer,
  addDrawer,
  addConnectorDrawer,
  chargingPoint,
  handleDeleteConnector,
  chargerTypes,
  inputFields,
  removeFieldsConnector,
  vendorIdDefault,
  selectedCity,
  // edit connector :

  EditConnectorDrawer,
  EditCh_PointIndex,
  handleOnclickEditConnectorOpen,
  handleCloseEditConnector,
  chargingConnectorEdit,
  // edit Charging Point
  handleChangeChPointEdit,
  EditChargingPointDrawer,
  handleCloseEditChPoint,
  handleOpenEditChPoint,
  handleChangeConnectorEdit,
  handleChargingTableEnableDisableModelOpen,
}) => {
  var propsIdData = [chargingPoint];

  var Data = data;

  const classes = useStyles();
  const columns = [
    {
      field: "vendor_name",
      headerName: "Name of Vendor",
    },
    {
      field: "name_of_charging_station",
      headerName: "Name of charging station",
    },
    {
      field: "name_of_network",
      headerName: "Name of network",
    },
    {
      field: "type_of_charging_station",
      headerName: "Type of charging station",
    },

    {
      field: "action",
      headerName: "Actions",
      valueGetter: (v, d) => {
        const StationDetail = {
          pathname: `/station/details/` + d.stationId,
          stationId: d.stationId,
        };

        return (
          <>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={0}
              sx={{
                flexDirection: { xs: "column", md: "row", lg: "row" },
              }}
            >
              <IconButton
                aria-label="show"
                sx={{
                  color: "green",
                  cursor: "pointer",
                }}
              >
                <Link href={StationDetail}>
                  <VisibilityOutlinedIcon
                    sx={{ opacity: "0.59", width: "95%", marginTop: "3.5px" }}
                  />
                </Link>
              </IconButton>

              <Switch
                checked={d.status}
                onClick={() =>
                  handleChargingTableEnableDisableModelOpen(
                    d.stationId,
                    d.status
                  )
                }
              />
            </Stack>
          </>
        );
      },
    },
  ];

  const [selectVendor, setSelectvendor] = React.useState("");

  return (
    <Box className={classes.center} sx={{ margin: "25px 0 0 0 " }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          marginBottom: "40px",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <ArrowBackIcon
            sx={{
              fontSize: "22px",
              margin: "3px 10px 10px 5px",
              color: "#707070",
            }}
            onClick={handleGoBack}
          />

          <Text
            variant="h4"
            component="div"
            gutterBottom
            className={classes.pageHeading}
          >
            CHARGING STATIONS LIST
          </Text>
        </Box>
        <AddChrgingPoint
          addDrawer={addDrawer}
          handleAddChPointClose={handleAddChPointClose}
          handleChangeChPointAdd={handleChangeChPointAdd}
          classes={classes}
          inputFields={inputFields}
          removeFieldsConnector={removeFieldsConnector}
          handleChangeConnector={handleChangeConnector}
          chargerTypes={chargerTypes}
          handleAddConnector={handleAddConnector}
          handleSubmitAddChPoint={handleSubmitAddChPoint}
        />
        <AddChargingConnectors
          addConnectorDrawerOpen={addConnectorDrawer}
          handleCloseAddConnectorDr={handleCloseAddConnectorDr}
          hendleChangeConnectorAdd={hendleChangeConnectorAdd}
          chargerType={chargerTypes}
          classes={classes}
          handleSubmitConnectorAdd={handleSubmitConnector}
        />
        <EditChargingConnector
          EditConnectorDrawerOpen={EditConnectorDrawer}
          chargingConnectorEditData={chargingConnectorEdit}
          handleCloseEditCtr={handleCloseEditConnector}
          chargerType={chargerTypes}
          classes={classes}
          handleChangeConnectorEdit={handleChangeConnectorEdit}
          handleSubmitEditConnector={handleSubmitEditConnector}
        />
        <EditChargingPoint
          EditChargingPointDrawer={EditChargingPointDrawer}
          handleCloseEditChPoint={handleCloseEditChPoint}
          propsIdData={propsIdData}
          classes={classes}
          EditCh_PointIndex={EditCh_PointIndex}
          handleChangeChPointEdit={handleChangeChPointEdit}
          handleSubmitEditChPoint={handleSubmitEditChPoint}
        />
        <Drawer
          anchor="right"
          open={viewDrawer}
          onClose={handleShowChPointClose}
          PaperProps={{
            sx: {
              width: "30%",
              padding: "2%",
              "@media (max-width:768px)": {
                marginLeft: "2rem",
                width: "20rem",
              },
            },
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Text
              sx={{
                margin: "20px 20px",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              Add Charging Points
            </Text>

            <HighlightOffIcon
              onClick={() => handleShowChPointClose()}
              sx={{ margin: "20px 20px", cursor: "pointer" }}
            />
          </Box>
          <ChargingPointShowDrawer
            props={chargingPoint}
            handleDeleteConnector={handleDeleteConnector}
            handleAddChPoint={handleAddChPoint}
            handleOpenAddConnectorDr={handleOpenAddConnectorDr}
            handleOnclickEditConnectorOpen={handleOnclickEditConnectorOpen}
            handleOpenEditChPoint={handleOpenEditChPoint}
          />
        </Drawer>

        <Box className={classes.city} sx={{ marginTop: "5px" }}>
          <InputLabel id="selected" sx={{ color: "#A2A7AE", fontSize: "14px" }}>
            Select Vendor
          </InputLabel>
          <Select
            sx={{
              width: "190px",
              height: "35px",
              marginBottom: "15px",
              fontSize: "14px",
            }}
            onChange={(e) => {
              setSelectvendor(e.target.value);
              handleOnchangeSelectCity(e.target.value);
            }}
            labelId="selected"
            label="Vendor"
            id="selected"
            placeholder="Select city"
            value={
              vendorIdDefault
                ? selectVendor
                  ? selectVendor
                  : vendorIdDefault
                : selectVendor
                ? selectVendor
                : "all2"
            }
          >
            <MenuItem sx={{ fontSize: "14px" }} selected value={"all2"}>
              All
            </MenuItem>
            {vendorSelect?.map(
              (e, index) => (
              
                (
                  <MenuItem
                    sx={{ fontSize: "14px" }}
                    key={index}
                    value={e?.vendor_id}
                  >
                    {e?.vendors_name}
                  </MenuItem>
                )
              )
            )}
          </Select>
        </Box>
      </Stack>
      <CTable
        columns={columns}
        isLoading={isLoading}
        data={Data}
        pagination={true}
        localPagination={true}
        page={0}
        rowsPerPage={5}
      ></CTable>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  pageHeading: {
    fontSize: "22px",
    fontfamily: "Nunito Sans",
    fontWeight: "400",
    textTransform: "none",
    color: "#707070",
    opacity: 1,

    "@media (max-width:768px)": {
      fontSize: "20px",
      fontWeight: "400",
    },
  },
  paper: {
    width: 250,
  },
  EditChargingConnectorDrower: {
    "@media (max-width:768px)": {},
  },
  paperPropsCss: {
    width: "21%",
    padding: "2%",
    margin: "10% 0 10% 70%",
    borderRadius: "10px",
    boxShadow: "0px 10px 10px 0px",
    background: "red",
  },
}));

export default ChargingStationTable;
